import React, { useState, useEffect } from 'react'
import { getSessionDetailsVkyc } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'

export default function VideoKyc({ admin, allDetail }) {
    const [loader, setLoader] = useState(false)
    const [data, setData] = useState({})
    const [errorMsg, setErrorMsg] = useState({ show: false, msg: "" })

    useEffect(() => {
        setLoader(true)
        getSessionDetailsVkyc(allDetail?.userId, callback => {
            console.log("call", callback)
            setData(callback)
            setLoader(false)
            if (callback?.status == 400) {
                setErrorMsg({ show: true, msg: callback?.data })
            }else{
                setData(callback?.data)
            }
        })
    }, [])
    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                errorMsg?.show ?
                    <h3 className='text-center' style={{ paddingTop: '40px' }}><i>{errorMsg?.msg}</i></h3>
                    :

                    <div className="row" style={{display:'flex',justifyContent:'center',paddingTop: '40px'}}>
                        <div className="col-sm-8">
                            <div className='details-body' style={{ boxShadow: 'grey 3px 3px 10px -8px' }}>
                                <div className="details-head">
                                    <div className="row">
                                        <div style={{ marginTop: '6px' }}>
                                            <b style={{ paddingLeft: '10px' }}>Video KYC</b>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ padding: '10px', background: '#fff', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
                                    <div className="row">
                                        <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">Last Webhook State</label>
                                            <p>{data?.lastWebhookState || "-"}</p>
                                        </div>
                                        <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">Last Webhook Status</label>
                                            <p>{data?.lastWebhookStatus || "-"}</p>
                                        </div>
                                        <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">kyc Status</label>
                                            <p>{data?.kycStatus || "-"}</p>
                                        </div>
                                       
                                    </div>
                                     <div className="row">
 <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">kyc Source</label>
                                            <p>{data?.kycSource || "-"}</p>
                                        </div>
                                        <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">Latitude</label>
                                            <p>{data?.latitude || "-"}</p>
                                        </div>
                                        <div className="col-sm-4 col-xs-12" style={{marginTop:'10px'}}>
                                            <label htmlFor="">Longitude</label>
                                            <p>{data?.longitude || "-"}</p>
                                        </div>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

        </>
    )
}
